import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { MiDetailFields } from "@miplatform/components";
import { handleInputRestrictions } from "@miplatform/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { MaterialCard } from "../MaterialCard/MaterialCard";
import { AddNoteDrawer } from "./AddNoteDrawer/AddNoteDrawer";
import { usePlanMaterialViewModel } from "./usePlanMaterialViewModel";

const schema = z.object({
  quantity: z.string().min(1, "Quantity is required"),
});

export function PlanMaterial({
  item,
  area = {},
  updateArea,
  planDetails,
  isLoading,
}) {
  const [openNoteDrawer, setOpenNoteDrawer] = useState(false);
  const material = area.materials?.find((mat) => mat.materialId === item.id);

  const {
    formState: { dirtyFields },
    control,
    getValues,
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: { quantity: material?.quantity || "" },
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    reset({ quantity: material?.quantity });
  }, [planDetails]);

  const { handleUpdateItem, getMenuOptions, isSuppliedByBuilder } =
    usePlanMaterialViewModel({
      updateArea,
      area,
      item,
      dirtyFields,
      getValues,
      openDrawer: () => setOpenNoteDrawer(true),
      reset,
    });

  const quantityField = [
    {
      name: "quantity",
      formControl: control,
      sx: { width: 50 },
      minWidth: 50,
      type: "number",
      onBlur: handleUpdateItem,
      onKeyDown: handleInputRestrictions,
      onInput: handleInputRestrictions,
      disabled: isLoading,
    },
  ];

  return (
    <>
      <MaterialCard
        item={item}
        leftAction={<MiDetailFields detailFields={quantityField} />}
        menuData={getMenuOptions()}
        fieldNote={material?.fieldNote || item?.fieldNote}
        showPrice
        isSuppliedByBuilder={isSuppliedByBuilder}
        isLoading={isLoading}
      />
      <AddNoteDrawer
        open={openNoteDrawer}
        onClose={() => setOpenNoteDrawer(false)}
        item={item}
        area={area}
        planDetails={planDetails}
        updateArea={updateArea}
        defaultFieldNote={material?.fieldNote}
      />
    </>
  );
}
